import React, { useEffect, useState } from 'react';
import { Grid, Button, Box } from "@mui/material";
import { styles } from "./styles";
import { styles as inputStyles } from "common/inputStyles";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { CSVLink } from "react-csv";
import { Colors } from "assets/colors";
import CommonUtil from "../../common/CommonUtil";

interface ActionButtons {
  label: string;
  icon?: any;
  onClickHandler: Function;
  buttonStyle: any;
}

interface TableHeaderProps {
  actionButtons: Array<ActionButtons>;
  searchVal: string;
  setSearchVal: Function;
  data: any;
  tabs?: Array<ActionButtons>;
  withFilter?: boolean;
  csvLabel?: string;
  screenName?: string;
}

const TruckTableHeader: React.FC<TableHeaderProps> = ({ actionButtons, searchVal, setSearchVal, data, tabs, withFilter, csvLabel ,screenName}) => {
  const [checkedData, setCheckedData] = useState<any>(null);
  const [formattedData, setFormattedData] = useState<any>(null);


  const transformUserRoles = (arr: any) =>  {
    let transformedArray: any = [];
    arr.forEach((obj: any) => {
      if (obj.hasOwnProperty('userRoleList')) {
        let transformedObj = {...obj};
        if (transformedObj.hasOwnProperty('userId')) {
          delete transformedObj['userId'];
        }
        if (transformedObj.hasOwnProperty('timeZone')) {
          delete transformedObj['timeZone'];
        }
        if (transformedObj.hasOwnProperty('dateFormat')) {
          delete transformedObj['dateFormat'];
        }
        if (transformedObj.hasOwnProperty('numberFormat')) {
          delete transformedObj['numberFormat'];
        }
        if (transformedObj.hasOwnProperty('permissionCount')) {
          delete transformedObj['permissionCount'];
        }
        if (transformedObj.hasOwnProperty('roleId')) {
          delete transformedObj['roleId'];
        }
        if (transformedObj.hasOwnProperty('truckId')) {
          delete transformedObj['roleId'];
        }
        const userRoles = transformedObj['userRoleList'].map((roleObj: any) => roleObj['roleName']);
        transformedObj['userRoleList'] = userRoles.join(', ');
        transformedArray.push(transformedObj);
      }
    });

    if(transformedArray.length > 0) {
      setCheckedData(transformedArray);
    } else {
      setCheckedData(data);
    }
  }

  const transformKey = (key: string) => {
    return key.replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/^./, (str) => str.toUpperCase());
  };

  const transformObjectKeys = (obj: any) => {
    const transformedObj = Object.keys(obj).reduce((acc, key) => {
      const transformedKey = transformKey(key);
      return { ...acc, [transformedKey]: obj[key] };
    }, {});
    return transformedObj;
  };

  useEffect(() => {
    if(checkedData !== null && checkedData.length > 0) {
      let transformedArray = checkedData.map((obj: any) => transformObjectKeys(obj));
      let rArray:any = [];
      let trucks:any = [];
      for(let i=0;i<transformedArray.length;i++){
        let truckkObj:any = {};
        if(screenName === CommonUtil.TRUCKS){
          truckkObj["Truck Number"] = transformedArray[i]["Truck Name"];
          truckkObj["Truck Type"] = transformedArray[i]["Truck Type"];
          truckkObj["Service Type"] = transformedArray[i]["Service Type"];
          truckkObj["Service Provider Name"] = transformedArray[i]["Service Provider Nme"];
          truckkObj["Segment Name"] = transformedArray[i]["Segment Name"];
          truckkObj["Warehouse Location"] = transformedArray[i]["Warehouse Location NAme"];
          truckkObj["Truck Status"] = transformedArray[i]["Truck Status"];
          truckkObj["Creation Date"] = transformedArray[i]["Creation Date"];
          truckkObj["Created By"] = transformedArray[i]["Created By"];
          truckkObj["Last Updated Date"] = transformedArray[i]["Last Update Date"];
          truckkObj["Last Updated By"] = transformedArray[i]["Last Updated By"];
          truckkObj["Device ID"] = transformedArray[i]["Device Id"];
        }else if(screenName === CommonUtil.DEVICES){
          truckkObj["Device ID"] = transformedArray[i]["Device Id"];
          truckkObj["Device Type"] = transformedArray[i]["Device Type Name"];
          truckkObj["Device Status"] = transformedArray[i]["Device Status"];
          truckkObj["Application"] = transformedArray[i]["Application"];
          truckkObj["Service Provider Name"] = transformedArray[i]["Service Provider Nme"];
          truckkObj["Segment Name"] = transformedArray[i]["Segment Name"];
          truckkObj["Observation 1 Description"] = transformedArray[i]["Observation1Description"];
          truckkObj["Observation 2 Description"] = transformedArray[i]["Observation2Description"];
          truckkObj["Observation 3 Description"] = transformedArray[i]["Observation3Description"];
          truckkObj["Attribute 1"] = transformedArray[i]["Attribute1"];
          truckkObj["Attribute 2"] = transformedArray[i]["Attribute2"];
          truckkObj["Attribute 3"] = transformedArray[i]["Attribute3"];
          truckkObj["Attribute 4"] = transformedArray[i]["Attribute4"];
          truckkObj["Creation Date"] = transformedArray[i]["Creation Date"];
          truckkObj["Created By"] = transformedArray[i]["Created By"];
          truckkObj["Last Updated Date"] = transformedArray[i]["Last Update Date"];
          truckkObj["Last Updated By"] = transformedArray[i]["Last Updated By"];
          truckkObj["Truck Number"] = transformedArray[i]["Truck Name"];
        }
        trucks.push(truckkObj);
      }
      setFormattedData(trucks);
    }
  }, [checkedData]);

  useEffect(() => {
    if(data.length > 0) {
      transformUserRoles(data);
    }
  }, [data]);

  return (
    <Grid item xs={12} sx={{ ...styles.container, justifyContent: tabs ? "space-between" : "flex-end" }}>
      {
        tabs &&
        <Grid sx={styles.buttonContainer}>
          {tabs.map((t, i) =>
            <Button key={i} sx={{ ...styles.buttons, ...t.buttonStyle, marginRight: 0 }} onClick={() => t.onClickHandler()}>
              {t.icon && t.icon}
              {t.label}
            </Button>
          )}
        </Grid>
      }
      <Grid sx={styles.buttonContainer}>
        {actionButtons.map((b, i) =>
          <Button key={i} sx={{ ...styles.buttons, ...b.buttonStyle }} onClick={() => b.onClickHandler()}>
            {b.icon && b.icon}
            {b.label}
          </Button>
        )}
        <CSVLink data={formattedData || []} style={{ textDecoration: 'none' }} filename={csvLabel ? csvLabel: 'download.csv'}>
          <Button sx={{ ...styles.buttons, backgroundColor: Colors.Purple }}>
            <FileDownloadOutlinedIcon sx={{ marginRight: ".5rem" }} />
            Download CSV
          </Button>
        </CSVLink>
        <Box sx={inputStyles.searchContainer}>
          <SearchOutlinedIcon sx={{ marginLeft: ".5rem" }} />
          <input type="text" placeholder='Search' value={searchVal} onChange={(e) => setSearchVal(e.target.value)} />
        </Box>
        {withFilter && <FilterAltIcon sx={styles.filterIcon} />}
      </Grid>

    </Grid>
  )
}

export default TruckTableHeader;
